import { get, put } from '@api/request';

export async function fetchCaseSettingOptions(
  { appraisalNoticeService },
  authenticationToken,
) {
  let url = `${appraisalNoticeService}/appraisal/casesetting/options`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCaseSetting(
    { appraisalNoticeService },
    authenticationToken,
  ) {
    let url = `${appraisalNoticeService}/appraisal/casesetting`;
    const { body } = await get(authenticationToken, url);
    return body;
  }
  

export async function updateCaseSetting(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalNoticeService}/appraisal/casesetting`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
